const apiUrl = "https://vocabulous-api-production.up.railway.app"
// get api endpoint url from deployer
export default apiUrl